module.exports = __webpack_public_path__ + "img/Bg_circle.68563dcc.svg";